import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Grouping,
  Lookup,
} from 'devextreme-react/data-grid';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import { useControlContent } from '../../../hooks/controlContent';

import ControlList from '../ControlList';
import GridLoader from '../../../components/GridLoader';

import { Board, BoardContent, BoardHeader } from '../../../components/Board';

import api from '../../../services/api';

export default function CostRate() {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobtitleSource] = useState({
    store: new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const response = await api.get('master/jobtitles');

        return response.data;
      },
    }),
    paginate: true,
  });
  const [officeSource] = useState({
    store: new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const response = await api.get('master/offices');

        return response.data;
      },
    }),
    paginate: true,
  });

  const { setControlContent, setPageTitle } = useControlContent();

  // Set control menu
  useEffect(() => {
    setPageTitle('Finance');
    setControlContent(<ControlList />);

    const costRateStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        try {
          setLoading(true);
          const response = await api.get('scheduling/cost-rates');

          setLoading(false);
          return response.data;
        } catch (err) {
          console.log('load cost-rates', err);
        }
      },
    });

    const costRateDataSource = new DataSource({
      store: costRateStore,
      paginate: true,
      reshapeOnPush: true,
    });

    setDataSource(costRateDataSource);
  }, [setControlContent, setPageTitle]);

  return (
    <Board>
      <BoardHeader
        title="Cost Rate"
        description="View cost rates (editable only through import)"
      />

      <BoardContent style={{ padding: 0, margin: 0, position: 'relative' }}>
        {loading ? (
          <GridLoader>
            <CircularProgress color="primary" />
          </GridLoader>
        ) : null}

        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          remoteOperations={false}
          key="ID"
          height="100%"
        >
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <Scrolling mode="infinite" />
          <Grouping autoExpandAll={false} />

          <Column dataField="IDPosition" caption="JobTitle">
            <Lookup
              dataSource={jobtitleSource}
              displayExpr="Name"
              valueExpr="ID"
            />
          </Column>
          <Column dataField="IDOffice" caption="Office">
            <Lookup
              dataSource={officeSource}
              displayExpr="Name"
              valueExpr="ID"
            />
          </Column>
          <Column dataField="MainValue" caption="Value (US Dollar)" />
          <Column dataField="Month" />
          <Column dataField="Year" />
        </DataGrid>
      </BoardContent>
    </Board>
  );
}
